export default __webpack_public_path__ + "static/media/desk-1081708_640.4e17b451.jpg";